export default __webpack_public_path__ + "static/media/bg.5067be86.webp";